function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.35 34V20H18.65V34H17.35Z",
  fill: "#27262A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5403 27.4595L11.4596 26.5403L18 33.0807L24.5403 26.5403L25.4596 27.4595L18 34.9191L10.5403 27.4595Z",
  fill: "#27262A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.65 0.274902V10.35H35.65V39C35.65 43.7589 31.759 47.65 27 47.65H8.99998C4.24099 47.65 0.349976 43.7589 0.349976 39V6.99995H0.354821C0.443272 5.18006 1.73353 3.71037 3.4725 3.36258L3.50067 3.35694L31.65 0.274902ZM1.64998 10.3442V39C1.64998 43.041 4.95896 46.35 8.99998 46.35H27C31.041 46.35 34.35 43.041 34.35 39V11.65H4.79998C3.56902 11.65 2.45533 11.151 1.64998 10.3442ZM1.64998 7.19995C1.64998 5.92097 2.51668 4.89225 3.70084 4.6428L30.35 1.72501V10.35H4.79998C3.05896 10.35 1.64998 8.94097 1.64998 7.19995Z",
  fill: "#27262A"
});

var SvgBook = function SvgBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book.d16e1c49.svg";
export { ForwardRef as ReactComponent };